import { NAV_ITEMS_BASE_STUDENT } from "features/navbar/consts";
import { NavItemLink } from "features/navbar/types";
import { ROUTES } from "routing/routes";

const settings: NavItemLink = {
  ...NAV_ITEMS_BASE_STUDENT.settings,
  to: ROUTES.DASHBOARD.SETTINGS.buildPath({})
};

export default settings;
